import React from 'react';
import PropTypes from 'prop-types';
import { ordinalize } from '../../../../../numberUtils';
import { interviewAvailabilityShape } from '../../../../../dateUtils';
import InterviewAttendees from '../../../../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../../../../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../../../../common/InterviewSubComponents/InterviewTimezone';

function PastInterviewCard({ interview }) {
  return (
    <div className="interview-info-container">
      <div className="interview-info-header past">
        <h2 className="medium-weight mb-8">
          {ordinalize(interview.round_number)}
          {' '}
          round -
          {' '}
          {interview.slot_duration_minutes}
          {' '}
          min call
        </h2>
        <InterviewTimeRange
          interviewTime={interview.accepted_time}
          containerClassName="normal-weight body-text-2 mb-4"
          opts={{
            timeZone: 'UTC',
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          }}
        />
        <div className="normal-weight body-text-2 muted-gray-text">
          <InterviewTimezone
            timezoneStr={interview.timezone}
            dateStr={interview.accepted_time.date}
          />
        </div>
      </div>
      <InterviewAttendees
        attendees={interview.attendees}
      />
    </div>
  );
}

PastInterviewCard.propTypes = {
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string,
    }).isRequired,
    timezone: PropTypes.string.isRequired,
    round_number: PropTypes.number,
  }).isRequired,
};

export default PastInterviewCard;
